import { Component, OnInit } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { UserService } from 'src/app/view/users/services/user.service';
import { ContextDataService } from '../../services/context.data-service';

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss']
})
export class LanguageSelectComponent implements OnInit {
  constructor(
    private ls: LocalizationService,
    private ctxDS: ContextDataService,
    private userService: UserService
  ) {}

  ngOnInit(): void {}

  public setLanguage(lan: string): void {
    this.ls.currentLang = lan;
    const uid = this.ctxDS.peekCurrentUserId();
    if (uid) this.userService.setUserLanguage(uid, lan);
  }
}
